export default function saleTerms() {
  return {
    event: 'sales_page_click_button_condition',
  }
}
